import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { getApp, _getProvider, _registerComponent, registerVersion, SDK_VERSION } from '@firebase/app';
import { FirebaseError, getModularInstance } from '@firebase/util';
import { Component } from '@firebase/component';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Error codes for requests made by the the XhrIo wrapper.
 */

var ErrorCode;

(function (ErrorCode) {
  ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
  ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
  ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})(ErrorCode || (ErrorCode = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Constants used in the Firebase Storage library.
 */

/**
 * Domain name for firebase storage.
 */


var DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */

var CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */

var DEFAULT_MAX_OPERATION_RETRY_TIME = 2 * 60 * 1000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */

var DEFAULT_MAX_UPLOAD_RETRY_TIME = 10 * 60 * 1000;
/**
 * An error returned by the Firebase Storage SDK.
 * @public
 */

var FirebaseStorageError = /*#__PURE__*/function (_FirebaseError) {
  _inherits(FirebaseStorageError, _FirebaseError);

  var _super = _createSuper(FirebaseStorageError);

  /**
   * @param code - A StorageErrorCode string to be prefixed with 'storage/' and
   *  added to the end of the message.
   * @param message  - Error message.
   */
  function FirebaseStorageError(code, message) {
    var _this;

    _classCallCheck(this, FirebaseStorageError);

    _this = _super.call(this, prependCode(code), "Firebase Storage: ".concat(message, " (").concat(prependCode(code), ")"));
    /**
     * Stores custom error data unque to FirebaseStorageError.
     */

    _this.customData = {
      serverResponse: null
    }; // Without this, `instanceof FirebaseStorageError`, in tests for example,
    // returns false.

    Object.setPrototypeOf(_assertThisInitialized(_this), FirebaseStorageError.prototype);
    return _this;
  }
  /**
   * Compares a StorageErrorCode against this error's code, filtering out the prefix.
   */


  _createClass(FirebaseStorageError, [{
    key: "_codeEquals",
    value: function _codeEquals(code) {
      return prependCode(code) === this.code;
    }
    /**
     * Error message including serverResponse if available.
     */

  }, {
    key: "message",
    get: function get() {
      if (this.customData.serverResponse) {
        return "".concat(this.message, "\n").concat(this.customData.serverResponse);
      } else {
        return this.message;
      }
    }
    /**
     * Optional response message that was added by the server.
     */

  }, {
    key: "serverResponse",
    get: function get() {
      return this.customData.serverResponse;
    },
    set: function set(serverResponse) {
      this.customData.serverResponse = serverResponse;
    }
  }]);

  return FirebaseStorageError;
}(FirebaseError);

function prependCode(code) {
  return 'storage/' + code;
}

function unknown() {
  var message = 'An unknown error occurred, please check the error payload for ' + 'server response.';
  return new FirebaseStorageError("unknown"
  /* UNKNOWN */
  , message);
}

function objectNotFound(path) {
  return new FirebaseStorageError("object-not-found"
  /* OBJECT_NOT_FOUND */
  , "Object '" + path + "' does not exist.");
}

function quotaExceeded(bucket) {
  return new FirebaseStorageError("quota-exceeded"
  /* QUOTA_EXCEEDED */
  , "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}

function unauthenticated() {
  var message = 'User is not authenticated, please authenticate using Firebase ' + 'Authentication and try again.';
  return new FirebaseStorageError("unauthenticated"
  /* UNAUTHENTICATED */
  , message);
}

function unauthorized(path) {
  return new FirebaseStorageError("unauthorized"
  /* UNAUTHORIZED */
  , "User does not have permission to access '" + path + "'.");
}

function retryLimitExceeded() {
  return new FirebaseStorageError("retry-limit-exceeded"
  /* RETRY_LIMIT_EXCEEDED */
  , 'Max retry time for operation exceeded, please try again.');
}

function canceled() {
  return new FirebaseStorageError("canceled"
  /* CANCELED */
  , 'User canceled the upload/download.');
}

function invalidUrl(url) {
  return new FirebaseStorageError("invalid-url"
  /* INVALID_URL */
  , "Invalid URL '" + url + "'.");
}

function invalidDefaultBucket(bucket) {
  return new FirebaseStorageError("invalid-default-bucket"
  /* INVALID_DEFAULT_BUCKET */
  , "Invalid default bucket '" + bucket + "'.");
}

function noDefaultBucket() {
  return new FirebaseStorageError("no-default-bucket"
  /* NO_DEFAULT_BUCKET */
  , 'No default bucket ' + "found. Did you set the '" + CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}

function cannotSliceBlob() {
  return new FirebaseStorageError("cannot-slice-blob"
  /* CANNOT_SLICE_BLOB */
  , 'Cannot slice blob for upload. Please retry the upload.');
}

function serverFileWrongSize() {
  return new FirebaseStorageError("server-file-wrong-size"
  /* SERVER_FILE_WRONG_SIZE */
  , 'Server recorded incorrect upload file size, please retry the upload.');
}

function noDownloadURL() {
  return new FirebaseStorageError("no-download-url"
  /* NO_DOWNLOAD_URL */
  , 'The given file does not have any download URLs.');
}

function invalidArgument(message) {
  return new FirebaseStorageError("invalid-argument"
  /* INVALID_ARGUMENT */
  , message);
}

function appDeleted() {
  return new FirebaseStorageError("app-deleted"
  /* APP_DELETED */
  , 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 */


function invalidRootOperation(name) {
  return new FirebaseStorageError("invalid-root-operation"
  /* INVALID_ROOT_OPERATION */
  , "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */


function invalidFormat(format, message) {
  return new FirebaseStorageError("invalid-format"
  /* INVALID_FORMAT */
  , "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */


function internalError(message) {
  throw new FirebaseStorageError("internal-error"
  /* INTERNAL_ERROR */
  , 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
 * doesn't work in React Native on Android.
 */


var NetworkXhrIo = /*#__PURE__*/function () {
  function NetworkXhrIo() {
    var _this2 = this;

    _classCallCheck(this, NetworkXhrIo);

    this.sent_ = false;
    this.xhr_ = new XMLHttpRequest();
    this.errorCode_ = ErrorCode.NO_ERROR;
    this.sendPromise_ = new Promise(function (resolve) {
      _this2.xhr_.addEventListener('abort', function () {
        _this2.errorCode_ = ErrorCode.ABORT;
        resolve(_this2);
      });

      _this2.xhr_.addEventListener('error', function () {
        _this2.errorCode_ = ErrorCode.NETWORK_ERROR;
        resolve(_this2);
      });

      _this2.xhr_.addEventListener('load', function () {
        resolve(_this2);
      });
    });
  }
  /**
   * @override
   */


  _createClass(NetworkXhrIo, [{
    key: "send",
    value: function send(url, method, body, headers) {
      if (this.sent_) {
        throw internalError('cannot .send() more than once');
      }

      this.sent_ = true;
      this.xhr_.open(method, url, true);

      if (headers !== undefined) {
        for (var key in headers) {
          if (headers.hasOwnProperty(key)) {
            this.xhr_.setRequestHeader(key, headers[key].toString());
          }
        }
      }

      if (body !== undefined) {
        this.xhr_.send(body);
      } else {
        this.xhr_.send();
      }

      return this.sendPromise_;
    }
    /**
     * @override
     */

  }, {
    key: "getErrorCode",
    value: function getErrorCode() {
      if (!this.sent_) {
        throw internalError('cannot .getErrorCode() before sending');
      }

      return this.errorCode_;
    }
    /**
     * @override
     */

  }, {
    key: "getStatus",
    value: function getStatus() {
      if (!this.sent_) {
        throw internalError('cannot .getStatus() before sending');
      }

      try {
        return this.xhr_.status;
      } catch (e) {
        return -1;
      }
    }
    /**
     * @override
     */

  }, {
    key: "getResponseText",
    value: function getResponseText() {
      if (!this.sent_) {
        throw internalError('cannot .getResponseText() before sending');
      }

      return this.xhr_.responseText;
    }
    /**
     * Aborts the request.
     * @override
     */

  }, {
    key: "abort",
    value: function abort() {
      this.xhr_.abort();
    }
    /**
     * @override
     */

  }, {
    key: "getResponseHeader",
    value: function getResponseHeader(header) {
      return this.xhr_.getResponseHeader(header);
    }
    /**
     * @override
     */

  }, {
    key: "addUploadProgressListener",
    value: function addUploadProgressListener(listener) {
      if (this.xhr_.upload != null) {
        this.xhr_.upload.addEventListener('progress', listener);
      }
    }
    /**
     * @override
     */

  }, {
    key: "removeUploadProgressListener",
    value: function removeUploadProgressListener(listener) {
      if (this.xhr_.upload != null) {
        this.xhr_.upload.removeEventListener('progress', listener);
      }
    }
  }]);

  return NetworkXhrIo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Factory-like class for creating XhrIo instances.
 */


var XhrIoPool = /*#__PURE__*/function () {
  function XhrIoPool() {
    _classCallCheck(this, XhrIoPool);
  }

  _createClass(XhrIoPool, [{
    key: "createXhrIo",
    value: function createXhrIo() {
      return new NetworkXhrIo();
    }
  }]);

  return XhrIoPool;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Firebase Storage location data.
 *
 * @internal
 */


var Location = /*#__PURE__*/function () {
  function Location(bucket, path) {
    _classCallCheck(this, Location);

    this.bucket = bucket;
    this.path_ = path;
  }

  _createClass(Location, [{
    key: "path",
    get: function get() {
      return this.path_;
    }
  }, {
    key: "isRoot",
    get: function get() {
      return this.path.length === 0;
    }
  }, {
    key: "fullServerUrl",
    value: function fullServerUrl() {
      var encode = encodeURIComponent;
      return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
  }, {
    key: "bucketOnlyServerUrl",
    value: function bucketOnlyServerUrl() {
      var encode = encodeURIComponent;
      return '/b/' + encode(this.bucket) + '/o';
    }
  }], [{
    key: "makeFromBucketSpec",
    value: function makeFromBucketSpec(bucketString, host) {
      var bucketLocation;

      try {
        bucketLocation = Location.makeFromUrl(bucketString, host);
      } catch (e) {
        // Not valid URL, use as-is. This lets you put bare bucket names in
        // config.
        return new Location(bucketString, '');
      }

      if (bucketLocation.path === '') {
        return bucketLocation;
      } else {
        throw invalidDefaultBucket(bucketString);
      }
    }
  }, {
    key: "makeFromUrl",
    value: function makeFromUrl(url, host) {
      var location = null;
      var bucketDomain = '([A-Za-z0-9.\\-_]+)';

      function gsModify(loc) {
        if (loc.path.charAt(loc.path.length - 1) === '/') {
          loc.path_ = loc.path_.slice(0, -1);
        }
      }

      var gsPath = '(/(.*))?$';
      var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
      var gsIndices = {
        bucket: 1,
        path: 3
      };

      function httpModify(loc) {
        loc.path_ = decodeURIComponent(loc.path);
      }

      var version = 'v[A-Za-z0-9_]+';
      var firebaseStorageHost = host.replace(/[.]/g, '\\.');
      var firebaseStoragePath = '(/([^?#]*).*)?$';
      var firebaseStorageRegExp = new RegExp("^https?://".concat(firebaseStorageHost, "/").concat(version, "/b/").concat(bucketDomain, "/o").concat(firebaseStoragePath), 'i');
      var firebaseStorageIndices = {
        bucket: 1,
        path: 3
      };
      var cloudStorageHost = host === DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
      var cloudStoragePath = '([^?#]*)';
      var cloudStorageRegExp = new RegExp("^https?://".concat(cloudStorageHost, "/").concat(bucketDomain, "/").concat(cloudStoragePath), 'i');
      var cloudStorageIndices = {
        bucket: 1,
        path: 2
      };
      var groups = [{
        regex: gsRegex,
        indices: gsIndices,
        postModify: gsModify
      }, {
        regex: firebaseStorageRegExp,
        indices: firebaseStorageIndices,
        postModify: httpModify
      }, {
        regex: cloudStorageRegExp,
        indices: cloudStorageIndices,
        postModify: httpModify
      }];

      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var captures = group.regex.exec(url);

        if (captures) {
          var bucketValue = captures[group.indices.bucket];
          var pathValue = captures[group.indices.path];

          if (!pathValue) {
            pathValue = '';
          }

          location = new Location(bucketValue, pathValue);
          group.postModify(location);
          break;
        }
      }

      if (location == null) {
        throw invalidUrl(url);
      }

      return location;
    }
  }]);

  return Location;
}();
/**
 * A request whose promise always fails.
 */


var FailRequest = /*#__PURE__*/function () {
  function FailRequest(error) {
    _classCallCheck(this, FailRequest);

    this.promise_ = Promise.reject(error);
  }
  /** @inheritDoc */


  _createClass(FailRequest, [{
    key: "getPromise",
    value: function getPromise() {
      return this.promise_;
    }
    /** @inheritDoc */

  }, {
    key: "cancel",
    value: function cancel() {
      var _appDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    }
  }]);

  return FailRequest;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */


function start(f, // eslint-disable-next-line @typescript-eslint/no-explicit-any
callback, timeout) {
  // TODO(andysoto): make this code cleaner (probably refactor into an actual
  // type instead of a bunch of functions with state shared in the closure)
  var waitSeconds = 1; // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
  // TODO: find a way to exclude Node type definition for storage because storage only works in browser
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var timeoutId = null;
  var hitTimeout = false;
  var cancelState = 0;

  function canceled() {
    return cancelState === 2;
  }

  var triggeredCallback = false;

  function triggerCallback() {
    if (!triggeredCallback) {
      triggeredCallback = true;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      callback.apply(null, args);
    }
  }

  function callWithDelay(millis) {
    timeoutId = setTimeout(function () {
      timeoutId = null;
      f(handler, canceled());
    }, millis);
  }

  function handler(success) {
    if (triggeredCallback) {
      return;
    }

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    if (success) {
      triggerCallback.call.apply(triggerCallback, [null, success].concat(args));
      return;
    }

    var mustStop = canceled() || hitTimeout;

    if (mustStop) {
      triggerCallback.call.apply(triggerCallback, [null, success].concat(args));
      return;
    }

    if (waitSeconds < 64) {
      /* TODO(andysoto): don't back off so quickly if we know we're offline. */
      waitSeconds *= 2;
    }

    var waitMillis;

    if (cancelState === 1) {
      cancelState = 2;
      waitMillis = 0;
    } else {
      waitMillis = (waitSeconds + Math.random()) * 1000;
    }

    callWithDelay(waitMillis);
  }

  var stopped = false;

  function stop(wasTimeout) {
    if (stopped) {
      return;
    }

    stopped = true;

    if (triggeredCallback) {
      return;
    }

    if (timeoutId !== null) {
      if (!wasTimeout) {
        cancelState = 2;
      }

      clearTimeout(timeoutId);
      callWithDelay(0);
    } else {
      if (!wasTimeout) {
        cancelState = 1;
      }
    }
  }

  callWithDelay(0);
  setTimeout(function () {
    hitTimeout = true;
    stop(true);
  }, timeout);
  return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */


function stop(id) {
  id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function isJustDef(p) {
  return p !== void 0;
} // eslint-disable-next-line @typescript-eslint/ban-types


function isFunction(p) {
  return typeof p === 'function';
}

function isNonArrayObject(p) {
  return typeof p === 'object' && !Array.isArray(p);
}

function isString(p) {
  return typeof p === 'string' || p instanceof String;
}

function isNativeBlob(p) {
  return isNativeBlobDefined() && p instanceof Blob;
}

function isNativeBlobDefined() {
  return typeof Blob !== 'undefined';
}

function validateNumber(argument, minValue, maxValue, value) {
  if (value < minValue) {
    throw invalidArgument("Invalid value for '".concat(argument, "'. Expected ").concat(minValue, " or greater."));
  }

  if (value > maxValue) {
    throw invalidArgument("Invalid value for '".concat(argument, "'. Expected ").concat(maxValue, " or less."));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function makeUrl(urlPart, host) {
  var protocolMatch = host.match(/^(\w+):\/\/.+/);
  var protocol = protocolMatch === null || protocolMatch === void 0 ? void 0 : protocolMatch[1];
  var origin = host;

  if (protocol == null) {
    origin = "https://".concat(host);
  }

  return "".concat(origin, "/v0").concat(urlPart);
}

function makeQueryString(params) {
  var encode = encodeURIComponent;
  var queryPart = '?';

  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      var nextPart = encode(key) + '=' + encode(params[key]);
      queryPart = queryPart + nextPart + '&';
    }
  } // Chop off the extra '&' or '?' on the end


  queryPart = queryPart.slice(0, -1);
  return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var NetworkRequest = /*#__PURE__*/function () {
  function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
    var _this3 = this;

    _classCallCheck(this, NetworkRequest);

    this.pendingXhr_ = null;
    this.backoffId_ = null;
    this.canceled_ = false;
    this.appDelete_ = false;
    this.url_ = url;
    this.method_ = method;
    this.headers_ = headers;
    this.body_ = body;
    this.successCodes_ = successCodes.slice();
    this.additionalRetryCodes_ = additionalRetryCodes.slice();
    this.callback_ = callback;
    this.errorCallback_ = errorCallback;
    this.progressCallback_ = progressCallback;
    this.timeout_ = timeout;
    this.pool_ = pool;
    this.promise_ = new Promise(function (resolve, reject) {
      _this3.resolve_ = resolve;
      _this3.reject_ = reject;

      _this3.start_();
    });
  }
  /**
   * Actually starts the retry loop.
   */


  _createClass(NetworkRequest, [{
    key: "start_",
    value: function start_() {
      var self = this;

      function doTheRequest(backoffCallback, canceled) {
        if (canceled) {
          backoffCallback(false, new RequestEndStatus(false, null, true));
          return;
        }

        var xhr = self.pool_.createXhrIo();
        self.pendingXhr_ = xhr;

        function progressListener(progressEvent) {
          var loaded = progressEvent.loaded;
          var total = progressEvent.lengthComputable ? progressEvent.total : -1;

          if (self.progressCallback_ !== null) {
            self.progressCallback_(loaded, total);
          }
        }

        if (self.progressCallback_ !== null) {
          xhr.addUploadProgressListener(progressListener);
        } // eslint-disable-next-line @typescript-eslint/no-floating-promises


        xhr.send(self.url_, self.method_, self.body_, self.headers_).then(function (xhr) {
          if (self.progressCallback_ !== null) {
            xhr.removeUploadProgressListener(progressListener);
          }

          self.pendingXhr_ = null;
          xhr = xhr;
          var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
          var status = xhr.getStatus();

          if (!hitServer || self.isRetryStatusCode_(status)) {
            var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
            backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
            return;
          }

          var successCode = self.successCodes_.indexOf(status) !== -1;
          backoffCallback(true, new RequestEndStatus(successCode, xhr));
        });
      }
      /**
       * @param requestWentThrough - True if the request eventually went
       *     through, false if it hit the retry limit or was canceled.
       */


      function backoffDone(requestWentThrough, status) {
        var resolve = self.resolve_;
        var reject = self.reject_;
        var xhr = status.xhr;

        if (status.wasSuccessCode) {
          try {
            var result = self.callback_(xhr, xhr.getResponseText());

            if (isJustDef(result)) {
              resolve(result);
            } else {
              resolve();
            }
          } catch (e) {
            reject(e);
          }
        } else {
          if (xhr !== null) {
            var err = unknown();
            err.serverResponse = xhr.getResponseText();

            if (self.errorCallback_) {
              reject(self.errorCallback_(xhr, err));
            } else {
              reject(err);
            }
          } else {
            if (status.canceled) {
              var _err = self.appDelete_ ? appDeleted() : canceled();

              reject(_err);
            } else {
              var _err2 = retryLimitExceeded();

              reject(_err2);
            }
          }
        }
      }

      if (this.canceled_) {
        backoffDone(false, new RequestEndStatus(false, null, true));
      } else {
        this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
      }
    }
    /** @inheritDoc */

  }, {
    key: "getPromise",
    value: function getPromise() {
      return this.promise_;
    }
    /** @inheritDoc */

  }, {
    key: "cancel",
    value: function cancel(appDelete) {
      this.canceled_ = true;
      this.appDelete_ = appDelete || false;

      if (this.backoffId_ !== null) {
        stop(this.backoffId_);
      }

      if (this.pendingXhr_ !== null) {
        this.pendingXhr_.abort();
      }
    }
  }, {
    key: "isRetryStatusCode_",
    value: function isRetryStatusCode_(status) {
      // The codes for which to retry came from this page:
      // https://cloud.google.com/storage/docs/exponential-backoff
      var isFiveHundredCode = status >= 500 && status < 600;
      var extraRetryCodes = [// Request Timeout: web server didn't receive full request in time.
      408, // Too Many Requests: you're getting rate-limited, basically.
      429];
      var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
      var isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
      return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    }
  }]);

  return NetworkRequest;
}();
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */


var RequestEndStatus = function RequestEndStatus(wasSuccessCode, xhr, canceled) {
  _classCallCheck(this, RequestEndStatus);

  this.wasSuccessCode = wasSuccessCode;
  this.xhr = xhr;
  this.canceled = !!canceled;
};

function addAuthHeader_(headers, authToken) {
  if (authToken !== null && authToken.length > 0) {
    headers['Authorization'] = 'Firebase ' + authToken;
  }
}

function addVersionHeader_(headers, firebaseVersion) {
  headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : 'AppManager');
}

function addGmpidHeader_(headers, appId) {
  if (appId) {
    headers['X-Firebase-GMPID'] = appId;
  }
}

function makeRequest(requestInfo, appId, authToken, pool, firebaseVersion) {
  var queryPart = makeQueryString(requestInfo.urlParams);
  var url = requestInfo.url + queryPart;
  var headers = Object.assign({}, requestInfo.headers);
  addGmpidHeader_(headers, appId);
  addAuthHeader_(headers, authToken);
  addVersionHeader_(headers, firebaseVersion);
  return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getBlobBuilder() {
  if (typeof BlobBuilder !== 'undefined') {
    return BlobBuilder;
  } else if (typeof WebKitBlobBuilder !== 'undefined') {
    return WebKitBlobBuilder;
  } else {
    return undefined;
  }
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */


function _getBlob() {
  var BlobBuilder = getBlobBuilder();

  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (BlobBuilder !== undefined) {
    var bb = new BlobBuilder();

    for (var i = 0; i < args.length; i++) {
      bb.append(args[i]);
    }

    return bb.getBlob();
  } else {
    if (isNativeBlobDefined()) {
      return new Blob(args);
    } else {
      throw new FirebaseStorageError("unsupported-environment"
      /* UNSUPPORTED_ENVIRONMENT */
      , "This browser doesn't seem to support creating Blobs");
    }
  }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */


function sliceBlob(blob, start, end) {
  if (blob.webkitSlice) {
    return blob.webkitSlice(start, end);
  } else if (blob.mozSlice) {
    return blob.mozSlice(start, end);
  } else if (blob.slice) {
    return blob.slice(start, end);
  }

  return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An enumeration of the possible string formats for upload.
 * @public
 */


var StringFormat = {
  /**
   * Indicates the string should be interpreted "raw", that is, as normal text.
   * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
   * sequence.
   * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
   * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
   */
  RAW: 'raw',

  /**
   * Indicates the string should be interpreted as base64-encoded data.
   * Padding characters (trailing '='s) are optional.
   * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
   * ad 69 8e fb e1 3a b7 bf eb 97
   */
  BASE64: 'base64',

  /**
   * Indicates the string should be interpreted as base64url-encoded data.
   * Padding characters (trailing '='s) are optional.
   * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
   * ad 69 8e fb e1 3a b7 bf eb 97
   */
  BASE64URL: 'base64url',

  /**
   * Indicates the string is a data URL, such as one obtained from
   * canvas.toDataURL().
   * Example: the string 'data:application/octet-stream;base64,aaaa'
   * becomes the byte sequence
   * 69 a6 9a
   * (the content-type "application/octet-stream" is also applied, but can
   * be overridden in the metadata object).
   */
  DATA_URL: 'data_url'
};

var StringData = function StringData(data, contentType) {
  _classCallCheck(this, StringData);

  this.data = data;
  this.contentType = contentType || null;
};

function dataFromString(format, stringData) {
  switch (format) {
    case StringFormat.RAW:
      return new StringData(utf8Bytes_(stringData));

    case StringFormat.BASE64:
    case StringFormat.BASE64URL:
      return new StringData(base64Bytes_(format, stringData));

    case StringFormat.DATA_URL:
      return new StringData(dataURLBytes_(stringData), dataURLContentType_(stringData));
    // do nothing
  } // assert(false);


  throw unknown();
}

function utf8Bytes_(value) {
  var b = [];

  for (var i = 0; i < value.length; i++) {
    var c = value.charCodeAt(i);

    if (c <= 127) {
      b.push(c);
    } else {
      if (c <= 2047) {
        b.push(192 | c >> 6, 128 | c & 63);
      } else {
        if ((c & 64512) === 55296) {
          // The start of a surrogate pair.
          var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;

          if (!valid) {
            // The second surrogate wasn't there.
            b.push(239, 191, 189);
          } else {
            var hi = c;
            var lo = value.charCodeAt(++i);
            c = 65536 | (hi & 1023) << 10 | lo & 1023;
            b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
          }
        } else {
          if ((c & 64512) === 56320) {
            // Invalid low surrogate.
            b.push(239, 191, 189);
          } else {
            b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
          }
        }
      }
    }
  }

  return new Uint8Array(b);
}

function percentEncodedBytes_(value) {
  var decoded;

  try {
    decoded = decodeURIComponent(value);
  } catch (e) {
    throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
  }

  return utf8Bytes_(decoded);
}

function base64Bytes_(format, value) {
  switch (format) {
    case StringFormat.BASE64:
      {
        var hasMinus = value.indexOf('-') !== -1;
        var hasUnder = value.indexOf('_') !== -1;

        if (hasMinus || hasUnder) {
          var invalidChar = hasMinus ? '-' : '_';
          throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
        }

        break;
      }

    case StringFormat.BASE64URL:
      {
        var hasPlus = value.indexOf('+') !== -1;
        var hasSlash = value.indexOf('/') !== -1;

        if (hasPlus || hasSlash) {
          var _invalidChar = hasPlus ? '+' : '/';

          throw invalidFormat(format, "Invalid character '" + _invalidChar + "' found: is it base64 encoded?");
        }

        value = value.replace(/-/g, '+').replace(/_/g, '/');
        break;
      }
    // do nothing
  }

  var bytes;

  try {
    bytes = atob(value);
  } catch (e) {
    throw invalidFormat(format, 'Invalid character found');
  }

  var array = new Uint8Array(bytes.length);

  for (var i = 0; i < bytes.length; i++) {
    array[i] = bytes.charCodeAt(i);
  }

  return array;
}

var DataURLParts = function DataURLParts(dataURL) {
  _classCallCheck(this, DataURLParts);

  this.base64 = false;
  this.contentType = null;
  var matches = dataURL.match(/^data:([^,]+)?,/);

  if (matches === null) {
    throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
  }

  var middle = matches[1] || null;

  if (middle != null) {
    this.base64 = endsWith(middle, ';base64');
    this.contentType = this.base64 ? middle.substring(0, middle.length - ';base64'.length) : middle;
  }

  this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
};

function dataURLBytes_(dataUrl) {
  var parts = new DataURLParts(dataUrl);

  if (parts.base64) {
    return base64Bytes_(StringFormat.BASE64, parts.rest);
  } else {
    return percentEncodedBytes_(parts.rest);
  }
}

function dataURLContentType_(dataUrl) {
  var parts = new DataURLParts(dataUrl);
  return parts.contentType;
}

function endsWith(s, end) {
  var longEnough = s.length >= end.length;

  if (!longEnough) {
    return false;
  }

  return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */


var FbsBlob = /*#__PURE__*/function () {
  function FbsBlob(data, elideCopy) {
    _classCallCheck(this, FbsBlob);

    var size = 0;
    var blobType = '';

    if (isNativeBlob(data)) {
      this.data_ = data;
      size = data.size;
      blobType = data.type;
    } else if (data instanceof ArrayBuffer) {
      if (elideCopy) {
        this.data_ = new Uint8Array(data);
      } else {
        this.data_ = new Uint8Array(data.byteLength);
        this.data_.set(new Uint8Array(data));
      }

      size = this.data_.length;
    } else if (data instanceof Uint8Array) {
      if (elideCopy) {
        this.data_ = data;
      } else {
        this.data_ = new Uint8Array(data.length);
        this.data_.set(data);
      }

      size = data.length;
    }

    this.size_ = size;
    this.type_ = blobType;
  }

  _createClass(FbsBlob, [{
    key: "size",
    value: function size() {
      return this.size_;
    }
  }, {
    key: "type",
    value: function type() {
      return this.type_;
    }
  }, {
    key: "slice",
    value: function slice(startByte, endByte) {
      if (isNativeBlob(this.data_)) {
        var realBlob = this.data_;
        var sliced = sliceBlob(realBlob, startByte, endByte);

        if (sliced === null) {
          return null;
        }

        return new FbsBlob(sliced);
      } else {
        var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
        return new FbsBlob(slice, true);
      }
    }
  }, {
    key: "uploadData",
    value: function uploadData() {
      return this.data_;
    }
  }], [{
    key: "getBlob",
    value: function getBlob() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      if (isNativeBlobDefined()) {
        var blobby = args.map(function (val) {
          if (val instanceof FbsBlob) {
            return val.data_;
          } else {
            return val;
          }
        });
        return new FbsBlob(_getBlob.apply(null, blobby));
      } else {
        var uint8Arrays = args.map(function (val) {
          if (isString(val)) {
            return dataFromString(StringFormat.RAW, val).data;
          } else {
            // Blobs don't exist, so this has to be a Uint8Array.
            return val.data_;
          }
        });
        var finalLength = 0;
        uint8Arrays.forEach(function (array) {
          finalLength += array.byteLength;
        });
        var merged = new Uint8Array(finalLength);
        var index = 0;
        uint8Arrays.forEach(function (array) {
          for (var i = 0; i < array.length; i++) {
            merged[index++] = array[i];
          }
        });
        return new FbsBlob(merged, true);
      }
    }
  }]);

  return FbsBlob;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */


function jsonObjectOrNull(s) {
  var obj;

  try {
    obj = JSON.parse(s);
  } catch (e) {
    return null;
  }

  if (isNonArrayObject(obj)) {
    return obj;
  } else {
    return null;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Contains helper methods for manipulating paths.
 */

/**
 * @return Null if the path is already at the root.
 */


function parent(path) {
  if (path.length === 0) {
    return null;
  }

  var index = path.lastIndexOf('/');

  if (index === -1) {
    return '';
  }

  var newPath = path.slice(0, index);
  return newPath;
}

function child(path, childPath) {
  var canonicalChildPath = childPath.split('/').filter(function (component) {
    return component.length > 0;
  }).join('/');

  if (path.length === 0) {
    return canonicalChildPath;
  } else {
    return path + '/' + canonicalChildPath;
  }
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */


function lastComponent(path) {
  var index = path.lastIndexOf('/', path.length - 2);

  if (index === -1) {
    return path;
  } else {
    return path.slice(index + 1);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function noXform_(metadata, value) {
  return value;
}

var Mapping = function Mapping(server, local, writable, xform) {
  _classCallCheck(this, Mapping);

  this.server = server;
  this.local = local || server;
  this.writable = !!writable;
  this.xform = xform || noXform_;
};

var mappings_ = null;

function xformPath(fullPath) {
  if (!isString(fullPath) || fullPath.length < 2) {
    return fullPath;
  } else {
    return lastComponent(fullPath);
  }
}

function getMappings() {
  if (mappings_) {
    return mappings_;
  }

  var mappings = [];
  mappings.push(new Mapping('bucket'));
  mappings.push(new Mapping('generation'));
  mappings.push(new Mapping('metageneration'));
  mappings.push(new Mapping('name', 'fullPath', true));

  function mappingsXformPath(_metadata, fullPath) {
    return xformPath(fullPath);
  }

  var nameMapping = new Mapping('name');
  nameMapping.xform = mappingsXformPath;
  mappings.push(nameMapping);
  /**
   * Coerces the second param to a number, if it is defined.
   */

  function xformSize(_metadata, size) {
    if (size !== undefined) {
      return Number(size);
    } else {
      return size;
    }
  }

  var sizeMapping = new Mapping('size');
  sizeMapping.xform = xformSize;
  mappings.push(sizeMapping);
  mappings.push(new Mapping('timeCreated'));
  mappings.push(new Mapping('updated'));
  mappings.push(new Mapping('md5Hash', null, true));
  mappings.push(new Mapping('cacheControl', null, true));
  mappings.push(new Mapping('contentDisposition', null, true));
  mappings.push(new Mapping('contentEncoding', null, true));
  mappings.push(new Mapping('contentLanguage', null, true));
  mappings.push(new Mapping('contentType', null, true));
  mappings.push(new Mapping('metadata', 'customMetadata', true));
  mappings_ = mappings;
  return mappings_;
}

function addRef(metadata, service) {
  function generateRef() {
    var bucket = metadata['bucket'];
    var path = metadata['fullPath'];
    var loc = new Location(bucket, path);
    return service._makeStorageReference(loc);
  }

  Object.defineProperty(metadata, 'ref', {
    get: generateRef
  });
}

function fromResource(service, resource, mappings) {
  var metadata = {};
  metadata['type'] = 'file';
  var len = mappings.length;

  for (var i = 0; i < len; i++) {
    var mapping = mappings[i];
    metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
  }

  addRef(metadata, service);
  return metadata;
}

function fromResourceString(service, resourceString, mappings) {
  var obj = jsonObjectOrNull(resourceString);

  if (obj === null) {
    return null;
  }

  var resource = obj;
  return fromResource(service, resource, mappings);
}

function downloadUrlFromResourceString(metadata, resourceString, host) {
  var obj = jsonObjectOrNull(resourceString);

  if (obj === null) {
    return null;
  }

  if (!isString(obj['downloadTokens'])) {
    // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
  }

  var tokens = obj['downloadTokens'];

  if (tokens.length === 0) {
    return null;
  }

  var encode = encodeURIComponent;
  var tokensList = tokens.split(',');
  var urls = tokensList.map(function (token) {
    var bucket = metadata['bucket'];
    var path = metadata['fullPath'];
    var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
    var base = makeUrl(urlPart, host);
    var queryString = makeQueryString({
      alt: 'media',
      token: token
    });
    return base + queryString;
  });
  return urls[0];
}

function toResourceString(metadata, mappings) {
  var resource = {};
  var len = mappings.length;

  for (var i = 0; i < len; i++) {
    var mapping = mappings[i];

    if (mapping.writable) {
      resource[mapping.server] = metadata[mapping.local];
    }
  }

  return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var PREFIXES_KEY = 'prefixes';
var ITEMS_KEY = 'items';

function fromBackendResponse(service, bucket, resource) {
  var listResult = {
    prefixes: [],
    items: [],
    nextPageToken: resource['nextPageToken']
  };

  if (resource[PREFIXES_KEY]) {
    var _iterator = _createForOfIteratorHelper(resource[PREFIXES_KEY]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var path = _step.value;
        var pathWithoutTrailingSlash = path.replace(/\/$/, '');

        var reference = service._makeStorageReference(new Location(bucket, pathWithoutTrailingSlash));

        listResult.prefixes.push(reference);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  if (resource[ITEMS_KEY]) {
    var _iterator2 = _createForOfIteratorHelper(resource[ITEMS_KEY]),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;

        var _reference = service._makeStorageReference(new Location(bucket, item['name']));

        listResult.items.push(_reference);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return listResult;
}

function fromResponseString(service, bucket, resourceString) {
  var obj = jsonObjectOrNull(resourceString);

  if (obj === null) {
    return null;
  }

  var resource = obj;
  return fromBackendResponse(service, bucket, resource);
}

var RequestInfo = function RequestInfo(url, method,
/**
 * Returns the value with which to resolve the request's promise. Only called
 * if the request is successful. Throw from this function to reject the
 * returned Request's promise with the thrown error.
 * Note: The XhrIo passed to this function may be reused after this callback
 * returns. Do not keep a reference to it in any way.
 */
handler, timeout) {
  _classCallCheck(this, RequestInfo);

  this.url = url;
  this.method = method;
  this.handler = handler;
  this.timeout = timeout;
  this.urlParams = {};
  this.headers = {};
  this.body = null;
  this.errorHandler = null;
  /**
   * Called with the current number of bytes uploaded and total size (-1 if not
   * computable) of the request body (i.e. used to report upload progress).
   */

  this.progressCallback = null;
  this.successCodes = [200];
  this.additionalRetryCodes = [];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
 */


function handlerCheck(cndn) {
  if (!cndn) {
    throw unknown();
  }
}

function metadataHandler(service, mappings) {
  function handler(xhr, text) {
    var metadata = fromResourceString(service, text, mappings);
    handlerCheck(metadata !== null);
    return metadata;
  }

  return handler;
}

function listHandler(service, bucket) {
  function handler(xhr, text) {
    var listResult = fromResponseString(service, bucket, text);
    handlerCheck(listResult !== null);
    return listResult;
  }

  return handler;
}

function downloadUrlHandler(service, mappings) {
  function handler(xhr, text) {
    var metadata = fromResourceString(service, text, mappings);
    handlerCheck(metadata !== null);
    return downloadUrlFromResourceString(metadata, text, service.host);
  }

  return handler;
}

function sharedErrorHandler(location) {
  function errorHandler(xhr, err) {
    var newErr;

    if (xhr.getStatus() === 401) {
      newErr = unauthenticated();
    } else {
      if (xhr.getStatus() === 402) {
        newErr = quotaExceeded(location.bucket);
      } else {
        if (xhr.getStatus() === 403) {
          newErr = unauthorized(location.path);
        } else {
          newErr = err;
        }
      }
    }

    newErr.serverResponse = err.serverResponse;
    return newErr;
  }

  return errorHandler;
}

function objectErrorHandler(location) {
  var shared = sharedErrorHandler(location);

  function errorHandler(xhr, err) {
    var newErr = shared(xhr, err);

    if (xhr.getStatus() === 404) {
      newErr = objectNotFound(location.path);
    }

    newErr.serverResponse = err.serverResponse;
    return newErr;
  }

  return errorHandler;
}

function getMetadata(service, location, mappings) {
  var urlPart = location.fullServerUrl();
  var url = makeUrl(urlPart, service.host);
  var method = 'GET';
  var timeout = service.maxOperationRetryTime;
  var requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
  requestInfo.errorHandler = objectErrorHandler(location);
  return requestInfo;
}

function list(service, location, delimiter, pageToken, maxResults) {
  var urlParams = {};

  if (location.isRoot) {
    urlParams['prefix'] = '';
  } else {
    urlParams['prefix'] = location.path + '/';
  }

  if (delimiter && delimiter.length > 0) {
    urlParams['delimiter'] = delimiter;
  }

  if (pageToken) {
    urlParams['pageToken'] = pageToken;
  }

  if (maxResults) {
    urlParams['maxResults'] = maxResults;
  }

  var urlPart = location.bucketOnlyServerUrl();
  var url = makeUrl(urlPart, service.host);
  var method = 'GET';
  var timeout = service.maxOperationRetryTime;
  var requestInfo = new RequestInfo(url, method, listHandler(service, location.bucket), timeout);
  requestInfo.urlParams = urlParams;
  requestInfo.errorHandler = sharedErrorHandler(location);
  return requestInfo;
}

function getDownloadUrl(service, location, mappings) {
  var urlPart = location.fullServerUrl();
  var url = makeUrl(urlPart, service.host);
  var method = 'GET';
  var timeout = service.maxOperationRetryTime;
  var requestInfo = new RequestInfo(url, method, downloadUrlHandler(service, mappings), timeout);
  requestInfo.errorHandler = objectErrorHandler(location);
  return requestInfo;
}

function updateMetadata(service, location, metadata, mappings) {
  var urlPart = location.fullServerUrl();
  var url = makeUrl(urlPart, service.host);
  var method = 'PATCH';
  var body = toResourceString(metadata, mappings);
  var headers = {
    'Content-Type': 'application/json; charset=utf-8'
  };
  var timeout = service.maxOperationRetryTime;
  var requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
  requestInfo.headers = headers;
  requestInfo.body = body;
  requestInfo.errorHandler = objectErrorHandler(location);
  return requestInfo;
}

function deleteObject(service, location) {
  var urlPart = location.fullServerUrl();
  var url = makeUrl(urlPart, service.host);
  var method = 'DELETE';
  var timeout = service.maxOperationRetryTime;

  function handler(_xhr, _text) {}

  var requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.successCodes = [200, 204];
  requestInfo.errorHandler = objectErrorHandler(location);
  return requestInfo;
}

function determineContentType_(metadata, blob) {
  return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}

function metadataForUpload_(location, blob, metadata) {
  var metadataClone = Object.assign({}, metadata);
  metadataClone['fullPath'] = location.path;
  metadataClone['size'] = blob.size();

  if (!metadataClone['contentType']) {
    metadataClone['contentType'] = determineContentType_(null, blob);
  }

  return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */


function multipartUpload(service, location, mappings, blob, metadata) {
  var urlPart = location.bucketOnlyServerUrl();
  var headers = {
    'X-Goog-Upload-Protocol': 'multipart'
  };

  function genBoundary() {
    var str = '';

    for (var i = 0; i < 2; i++) {
      str = str + Math.random().toString().slice(2);
    }

    return str;
  }

  var boundary = genBoundary();
  headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
  var metadata_ = metadataForUpload_(location, blob, metadata);
  var metadataString = toResourceString(metadata_, mappings);
  var preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
  var postBlobPart = '\r\n--' + boundary + '--';
  var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);

  if (body === null) {
    throw cannotSliceBlob();
  }

  var urlParams = {
    name: metadata_['fullPath']
  };
  var url = makeUrl(urlPart, service.host);
  var method = 'POST';
  var timeout = service.maxUploadRetryTime;
  var requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
  requestInfo.urlParams = urlParams;
  requestInfo.headers = headers;
  requestInfo.body = body.uploadData();
  requestInfo.errorHandler = sharedErrorHandler(location);
  return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */


var ResumableUploadStatus = function ResumableUploadStatus(current, total, finalized, metadata) {
  _classCallCheck(this, ResumableUploadStatus);

  this.current = current;
  this.total = total;
  this.finalized = !!finalized;
  this.metadata = metadata || null;
};

function checkResumeHeader_(xhr, allowed) {
  var status = null;

  try {
    status = xhr.getResponseHeader('X-Goog-Upload-Status');
  } catch (e) {
    handlerCheck(false);
  }

  var allowedStatus = allowed || ['active'];
  handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
  return status;
}

function createResumableUpload(service, location, mappings, blob, metadata) {
  var urlPart = location.bucketOnlyServerUrl();
  var metadataForUpload = metadataForUpload_(location, blob, metadata);
  var urlParams = {
    name: metadataForUpload['fullPath']
  };
  var url = makeUrl(urlPart, service.host);
  var method = 'POST';
  var headers = {
    'X-Goog-Upload-Protocol': 'resumable',
    'X-Goog-Upload-Command': 'start',
    'X-Goog-Upload-Header-Content-Length': blob.size(),
    'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
    'Content-Type': 'application/json; charset=utf-8'
  };
  var body = toResourceString(metadataForUpload, mappings);
  var timeout = service.maxUploadRetryTime;

  function handler(xhr) {
    checkResumeHeader_(xhr);
    var url;

    try {
      url = xhr.getResponseHeader('X-Goog-Upload-URL');
    } catch (e) {
      handlerCheck(false);
    }

    handlerCheck(isString(url));
    return url;
  }

  var requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.urlParams = urlParams;
  requestInfo.headers = headers;
  requestInfo.body = body;
  requestInfo.errorHandler = sharedErrorHandler(location);
  return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */


function getResumableUploadStatus(service, location, url, blob) {
  var headers = {
    'X-Goog-Upload-Command': 'query'
  };

  function handler(xhr) {
    var status = checkResumeHeader_(xhr, ['active', 'final']);
    var sizeString = null;

    try {
      sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
    } catch (e) {
      handlerCheck(false);
    }

    if (!sizeString) {
      // null or empty string
      handlerCheck(false);
    }

    var size = Number(sizeString);
    handlerCheck(!isNaN(size));
    return new ResumableUploadStatus(size, blob.size(), status === 'final');
  }

  var method = 'POST';
  var timeout = service.maxUploadRetryTime;
  var requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.headers = headers;
  requestInfo.errorHandler = sharedErrorHandler(location);
  return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */


var RESUMABLE_UPLOAD_CHUNK_SIZE = 256 * 1024;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */

function continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
  // TODO(andysoto): standardize on internal asserts
  // assert(!(opt_status && opt_status.finalized));
  var status_ = new ResumableUploadStatus(0, 0);

  if (status) {
    status_.current = status.current;
    status_.total = status.total;
  } else {
    status_.current = 0;
    status_.total = blob.size();
  }

  if (blob.size() !== status_.total) {
    throw serverFileWrongSize();
  }

  var bytesLeft = status_.total - status_.current;
  var bytesToUpload = bytesLeft;

  if (chunkSize > 0) {
    bytesToUpload = Math.min(bytesToUpload, chunkSize);
  }

  var startByte = status_.current;
  var endByte = startByte + bytesToUpload;
  var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
  var headers = {
    'X-Goog-Upload-Command': uploadCommand,
    'X-Goog-Upload-Offset': status_.current
  };
  var body = blob.slice(startByte, endByte);

  if (body === null) {
    throw cannotSliceBlob();
  }

  function handler(xhr, text) {
    // TODO(andysoto): Verify the MD5 of each uploaded range:
    // the 'x-range-md5' header comes back with status code 308 responses.
    // We'll only be able to bail out though, because you can't re-upload a
    // range that you previously uploaded.
    var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
    var newCurrent = status_.current + bytesToUpload;
    var size = blob.size();
    var metadata;

    if (uploadStatus === 'final') {
      metadata = metadataHandler(service, mappings)(xhr, text);
    } else {
      metadata = null;
    }

    return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
  }

  var method = 'POST';
  var timeout = service.maxUploadRetryTime;
  var requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.headers = headers;
  requestInfo.body = body.uploadData();
  requestInfo.progressCallback = progressCallback || null;
  requestInfo.errorHandler = sharedErrorHandler(location);
  return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Represents the current state of a running upload.
 */


var TaskState = {
  /** The task is currently transferring data. */
  RUNNING: 'running',

  /** The task was paused by the user. */
  PAUSED: 'paused',

  /** The task completed successfully. */
  SUCCESS: 'success',

  /** The task was canceled. */
  CANCELED: 'canceled',

  /** The task failed with an error. */
  ERROR: 'error'
};

function taskStateFromInternalTaskState(state) {
  switch (state) {
    case "running"
    /* RUNNING */
    :
    case "pausing"
    /* PAUSING */
    :
    case "canceling"
    /* CANCELING */
    :
      return TaskState.RUNNING;

    case "paused"
    /* PAUSED */
    :
      return TaskState.PAUSED;

    case "success"
    /* SUCCESS */
    :
      return TaskState.SUCCESS;

    case "canceled"
    /* CANCELED */
    :
      return TaskState.CANCELED;

    case "error"
    /* ERROR */
    :
      return TaskState.ERROR;

    default:
      // TODO(andysoto): assert(false);
      return TaskState.ERROR;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Observer = function Observer(nextOrObserver, error, complete) {
  _classCallCheck(this, Observer);

  var asFunctions = isFunction(nextOrObserver) || error != null || complete != null;

  if (asFunctions) {
    this.next = nextOrObserver;
    this.error = error;
    this.complete = complete;
  } else {
    var observer = nextOrObserver;
    this.next = observer.next;
    this.error = observer.error;
    this.complete = observer.complete;
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */
// eslint-disable-next-line @typescript-eslint/ban-types


function async(f) {
  return function () {
    for (var _len5 = arguments.length, argsToForward = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      argsToForward[_key5] = arguments[_key5];
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    Promise.resolve().then(function () {
      return f.apply(void 0, argsToForward);
    });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */


var UploadTask = /*#__PURE__*/function () {
  /**
   * @param ref - The firebaseStorage.Reference object this task came
   *     from, untyped to avoid cyclic dependencies.
   * @param blob - The blob to upload.
   */
  function UploadTask(ref, blob) {
    var _this4 = this;

    var metadata = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, UploadTask);

    /**
     * Number of bytes transferred so far.
     */
    this._transferred = 0;
    this._needToFetchStatus = false;
    this._needToFetchMetadata = false;
    this._observers = [];
    this._error = undefined;
    this._uploadUrl = undefined;
    this._request = undefined;
    this._chunkMultiplier = 1;
    this._resolve = undefined;
    this._reject = undefined;
    this._ref = ref;
    this._blob = blob;
    this._metadata = metadata;
    this._mappings = getMappings();
    this._resumable = this._shouldDoResumable(this._blob);
    this._state = "running"
    /* RUNNING */
    ;

    this._errorHandler = function (error) {
      _this4._request = undefined;
      _this4._chunkMultiplier = 1;

      if (error._codeEquals("canceled"
      /* CANCELED */
      )) {
        _this4._needToFetchStatus = true;

        _this4.completeTransitions_();
      } else {
        _this4._error = error;

        _this4._transition("error"
        /* ERROR */
        );
      }
    };

    this._metadataErrorHandler = function (error) {
      _this4._request = undefined;

      if (error._codeEquals("canceled"
      /* CANCELED */
      )) {
        _this4.completeTransitions_();
      } else {
        _this4._error = error;

        _this4._transition("error"
        /* ERROR */
        );
      }
    };

    this._promise = new Promise(function (resolve, reject) {
      _this4._resolve = resolve;
      _this4._reject = reject;

      _this4._start();
    }); // Prevent uncaught rejections on the internal promise from bubbling out
    // to the top level with a dummy handler.

    this._promise.then(null, function () {});
  }

  _createClass(UploadTask, [{
    key: "_makeProgressCallback",
    value: function _makeProgressCallback() {
      var _this5 = this;

      var sizeBefore = this._transferred;
      return function (loaded) {
        return _this5._updateProgress(sizeBefore + loaded);
      };
    }
  }, {
    key: "_shouldDoResumable",
    value: function _shouldDoResumable(blob) {
      return blob.size() > 256 * 1024;
    }
  }, {
    key: "_start",
    value: function _start() {
      if (this._state !== "running"
      /* RUNNING */
      ) {
          // This can happen if someone pauses us in a resume callback, for example.
          return;
        }

      if (this._request !== undefined) {
        return;
      }

      if (this._resumable) {
        if (this._uploadUrl === undefined) {
          this._createResumable();
        } else {
          if (this._needToFetchStatus) {
            this._fetchStatus();
          } else {
            if (this._needToFetchMetadata) {
              // Happens if we miss the metadata on upload completion.
              this._fetchMetadata();
            } else {
              this._continueUpload();
            }
          }
        }
      } else {
        this._oneShotUpload();
      }
    }
  }, {
    key: "_resolveToken",
    value: function _resolveToken(callback) {
      var _this6 = this;

      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this._ref.storage._getAuthToken().then(function (authToken) {
        switch (_this6._state) {
          case "running"
          /* RUNNING */
          :
            callback(authToken);
            break;

          case "canceling"
          /* CANCELING */
          :
            _this6._transition("canceled"
            /* CANCELED */
            );

            break;

          case "pausing"
          /* PAUSING */
          :
            _this6._transition("paused"
            /* PAUSED */
            );

            break;
        }
      });
    } // TODO(andysoto): assert false

  }, {
    key: "_createResumable",
    value: function _createResumable() {
      var _this7 = this;

      this._resolveToken(function (authToken) {
        var requestInfo = createResumableUpload(_this7._ref.storage, _this7._ref._location, _this7._mappings, _this7._blob, _this7._metadata);

        var createRequest = _this7._ref.storage._makeRequest(requestInfo, authToken);

        _this7._request = createRequest;
        createRequest.getPromise().then(function (url) {
          _this7._request = undefined;
          _this7._uploadUrl = url;
          _this7._needToFetchStatus = false;

          _this7.completeTransitions_();
        }, _this7._errorHandler);
      });
    }
  }, {
    key: "_fetchStatus",
    value: function _fetchStatus() {
      var _this8 = this;

      // TODO(andysoto): assert(this.uploadUrl_ !== null);
      var url = this._uploadUrl;

      this._resolveToken(function (authToken) {
        var requestInfo = getResumableUploadStatus(_this8._ref.storage, _this8._ref._location, url, _this8._blob);

        var statusRequest = _this8._ref.storage._makeRequest(requestInfo, authToken);

        _this8._request = statusRequest;
        statusRequest.getPromise().then(function (status) {
          status = status;
          _this8._request = undefined;

          _this8._updateProgress(status.current);

          _this8._needToFetchStatus = false;

          if (status.finalized) {
            _this8._needToFetchMetadata = true;
          }

          _this8.completeTransitions_();
        }, _this8._errorHandler);
      });
    }
  }, {
    key: "_continueUpload",
    value: function _continueUpload() {
      var _this9 = this;

      var chunkSize = RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
      var status = new ResumableUploadStatus(this._transferred, this._blob.size()); // TODO(andysoto): assert(this.uploadUrl_ !== null);

      var url = this._uploadUrl;

      this._resolveToken(function (authToken) {
        var requestInfo;

        try {
          requestInfo = continueResumableUpload(_this9._ref._location, _this9._ref.storage, url, _this9._blob, chunkSize, _this9._mappings, status, _this9._makeProgressCallback());
        } catch (e) {
          _this9._error = e;

          _this9._transition("error"
          /* ERROR */
          );

          return;
        }

        var uploadRequest = _this9._ref.storage._makeRequest(requestInfo, authToken);

        _this9._request = uploadRequest;
        uploadRequest.getPromise().then(function (newStatus) {
          _this9._increaseMultiplier();

          _this9._request = undefined;

          _this9._updateProgress(newStatus.current);

          if (newStatus.finalized) {
            _this9._metadata = newStatus.metadata;

            _this9._transition("success"
            /* SUCCESS */
            );
          } else {
            _this9.completeTransitions_();
          }
        }, _this9._errorHandler);
      });
    }
  }, {
    key: "_increaseMultiplier",
    value: function _increaseMultiplier() {
      var currentSize = RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier; // Max chunk size is 32M.

      if (currentSize < 32 * 1024 * 1024) {
        this._chunkMultiplier *= 2;
      }
    }
  }, {
    key: "_fetchMetadata",
    value: function _fetchMetadata() {
      var _this10 = this;

      this._resolveToken(function (authToken) {
        var requestInfo = getMetadata(_this10._ref.storage, _this10._ref._location, _this10._mappings);

        var metadataRequest = _this10._ref.storage._makeRequest(requestInfo, authToken);

        _this10._request = metadataRequest;
        metadataRequest.getPromise().then(function (metadata) {
          _this10._request = undefined;
          _this10._metadata = metadata;

          _this10._transition("success"
          /* SUCCESS */
          );
        }, _this10._metadataErrorHandler);
      });
    }
  }, {
    key: "_oneShotUpload",
    value: function _oneShotUpload() {
      var _this11 = this;

      this._resolveToken(function (authToken) {
        var requestInfo = multipartUpload(_this11._ref.storage, _this11._ref._location, _this11._mappings, _this11._blob, _this11._metadata);

        var multipartRequest = _this11._ref.storage._makeRequest(requestInfo, authToken);

        _this11._request = multipartRequest;
        multipartRequest.getPromise().then(function (metadata) {
          _this11._request = undefined;
          _this11._metadata = metadata;

          _this11._updateProgress(_this11._blob.size());

          _this11._transition("success"
          /* SUCCESS */
          );
        }, _this11._errorHandler);
      });
    }
  }, {
    key: "_updateProgress",
    value: function _updateProgress(transferred) {
      var old = this._transferred;
      this._transferred = transferred; // A progress update can make the "transferred" value smaller (e.g. a
      // partial upload not completed by server, after which the "transferred"
      // value may reset to the value at the beginning of the request).

      if (this._transferred !== old) {
        this._notifyObservers();
      }
    }
  }, {
    key: "_transition",
    value: function _transition(state) {
      if (this._state === state) {
        return;
      }

      switch (state) {
        case "canceling"
        /* CANCELING */
        :
          // TODO(andysoto):
          // assert(this.state_ === InternalTaskState.RUNNING ||
          //        this.state_ === InternalTaskState.PAUSING);
          this._state = state;

          if (this._request !== undefined) {
            this._request.cancel();
          }

          break;

        case "pausing"
        /* PAUSING */
        :
          // TODO(andysoto):
          // assert(this.state_ === InternalTaskState.RUNNING);
          this._state = state;

          if (this._request !== undefined) {
            this._request.cancel();
          }

          break;

        case "running"
        /* RUNNING */
        :
          // TODO(andysoto):
          // assert(this.state_ === InternalTaskState.PAUSED ||
          //        this.state_ === InternalTaskState.PAUSING);
          var wasPaused = this._state === "paused"
          /* PAUSED */
          ;
          this._state = state;

          if (wasPaused) {
            this._notifyObservers();

            this._start();
          }

          break;

        case "paused"
        /* PAUSED */
        :
          // TODO(andysoto):
          // assert(this.state_ === InternalTaskState.PAUSING);
          this._state = state;

          this._notifyObservers();

          break;

        case "canceled"
        /* CANCELED */
        :
          // TODO(andysoto):
          // assert(this.state_ === InternalTaskState.PAUSED ||
          //        this.state_ === InternalTaskState.CANCELING);
          this._error = canceled();
          this._state = state;

          this._notifyObservers();

          break;

        case "error"
        /* ERROR */
        :
          // TODO(andysoto):
          // assert(this.state_ === InternalTaskState.RUNNING ||
          //        this.state_ === InternalTaskState.PAUSING ||
          //        this.state_ === InternalTaskState.CANCELING);
          this._state = state;

          this._notifyObservers();

          break;

        case "success"
        /* SUCCESS */
        :
          // TODO(andysoto):
          // assert(this.state_ === InternalTaskState.RUNNING ||
          //        this.state_ === InternalTaskState.PAUSING ||
          //        this.state_ === InternalTaskState.CANCELING);
          this._state = state;

          this._notifyObservers();

          break;
      }
    }
  }, {
    key: "completeTransitions_",
    value: function completeTransitions_() {
      switch (this._state) {
        case "pausing"
        /* PAUSING */
        :
          this._transition("paused"
          /* PAUSED */
          );

          break;

        case "canceling"
        /* CANCELING */
        :
          this._transition("canceled"
          /* CANCELED */
          );

          break;

        case "running"
        /* RUNNING */
        :
          this._start();

          break;
      }
    }
    /**
     * A snapshot of the current task state.
     */

  }, {
    key: "snapshot",
    get: function get() {
      var externalState = taskStateFromInternalTaskState(this._state);
      return {
        bytesTransferred: this._transferred,
        totalBytes: this._blob.size(),
        state: externalState,
        metadata: this._metadata,
        task: this,
        ref: this._ref
      };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `FirebaseStorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */

  }, {
    key: "on",
    value: function on(type, nextOrObserver, error, completed) {
      var _this12 = this;

      var observer = new Observer(nextOrObserver, error, completed);

      this._addObserver(observer);

      return function () {
        _this12._removeObserver(observer);
      };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */

  }, {
    key: "then",
    value: function then(onFulfilled, onRejected) {
      // These casts are needed so that TypeScript can infer the types of the
      // resulting Promise.
      return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */

  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */

  }, {
    key: "_addObserver",
    value: function _addObserver(observer) {
      this._observers.push(observer);

      this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */

  }, {
    key: "_removeObserver",
    value: function _removeObserver(observer) {
      var i = this._observers.indexOf(observer);

      if (i !== -1) {
        this._observers.splice(i, 1);
      }
    }
  }, {
    key: "_notifyObservers",
    value: function _notifyObservers() {
      var _this13 = this;

      this._finishPromise();

      var observers = this._observers.slice();

      observers.forEach(function (observer) {
        _this13._notifyObserver(observer);
      });
    }
  }, {
    key: "_finishPromise",
    value: function _finishPromise() {
      if (this._resolve !== undefined) {
        var triggered = true;

        switch (taskStateFromInternalTaskState(this._state)) {
          case TaskState.SUCCESS:
            async(this._resolve.bind(null, this.snapshot))();
            break;

          case TaskState.CANCELED:
          case TaskState.ERROR:
            var toCall = this._reject;
            async(toCall.bind(null, this._error))();
            break;

          default:
            triggered = false;
            break;
        }

        if (triggered) {
          this._resolve = undefined;
          this._reject = undefined;
        }
      }
    }
  }, {
    key: "_notifyObserver",
    value: function _notifyObserver(observer) {
      var externalState = taskStateFromInternalTaskState(this._state);

      switch (externalState) {
        case TaskState.RUNNING:
        case TaskState.PAUSED:
          if (observer.next) {
            async(observer.next.bind(observer, this.snapshot))();
          }

          break;

        case TaskState.SUCCESS:
          if (observer.complete) {
            async(observer.complete.bind(observer))();
          }

          break;

        case TaskState.CANCELED:
        case TaskState.ERROR:
          if (observer.error) {
            async(observer.error.bind(observer, this._error))();
          }

          break;

        default:
          // TODO(andysoto): assert(false);
          if (observer.error) {
            async(observer.error.bind(observer, this._error))();
          }

      }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */

  }, {
    key: "resume",
    value: function resume() {
      var valid = this._state === "paused"
      /* PAUSED */
      || this._state === "pausing"
      /* PAUSING */
      ;

      if (valid) {
        this._transition("running"
        /* RUNNING */
        );
      }

      return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */

  }, {
    key: "pause",
    value: function pause() {
      var valid = this._state === "running"
      /* RUNNING */
      ;

      if (valid) {
        this._transition("pausing"
        /* PAUSING */
        );
      }

      return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */

  }, {
    key: "cancel",
    value: function cancel() {
      var valid = this._state === "running"
      /* RUNNING */
      || this._state === "pausing"
      /* PAUSING */
      ;

      if (valid) {
        this._transition("canceling"
        /* CANCELING */
        );
      }

      return valid;
    }
  }]);

  return UploadTask;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */


var Reference = /*#__PURE__*/function () {
  function Reference(_service, location) {
    _classCallCheck(this, Reference);

    this._service = _service;

    if (location instanceof Location) {
      this._location = location;
    } else {
      this._location = Location.makeFromUrl(location, _service.host);
    }
  }
  /**
   * Returns the URL for the bucket and path this object references,
   *     in the form gs://<bucket>/<object-path>
   * @override
   */


  _createClass(Reference, [{
    key: "toString",
    value: function toString() {
      return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
  }, {
    key: "_newRef",
    value: function _newRef(service, location) {
      return new Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */

  }, {
    key: "root",
    get: function get() {
      var location = new Location(this._location.bucket, '');
      return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */

  }, {
    key: "bucket",
    get: function get() {
      return this._location.bucket;
    }
    /**
     * The full path of this object.
     */

  }, {
    key: "fullPath",
    get: function get() {
      return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */

  }, {
    key: "name",
    get: function get() {
      return lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */

  }, {
    key: "storage",
    get: function get() {
      return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */

  }, {
    key: "parent",
    get: function get() {
      var newPath = parent(this._location.path);

      if (newPath === null) {
        return null;
      }

      var location = new Location(this._location.bucket, newPath);
      return new Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */

  }, {
    key: "_throwIfRoot",
    value: function _throwIfRoot(name) {
      if (this._location.path === '') {
        throw invalidRootOperation(name);
      }
    }
  }]);

  return Reference;
}();
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */


function uploadBytes(ref, data, metadata) {
  ref._throwIfRoot('uploadBytes');

  return ref.storage._getAuthToken().then(function (authToken) {
    var requestInfo = multipartUpload(ref.storage, ref._location, getMappings(), new FbsBlob(data, true), metadata);

    var multipartRequest = ref.storage._makeRequest(requestInfo, authToken);

    return multipartRequest.getPromise();
  }).then(function (finalMetadata) {
    return {
      metadata: finalMetadata,
      ref: ref
    };
  });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */


function uploadBytesResumable(ref, data, metadata) {
  ref._throwIfRoot('uploadBytesResumable');

  return new UploadTask(ref, new FbsBlob(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */


function uploadString(ref, value) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : StringFormat.RAW;
  var metadata = arguments.length > 3 ? arguments[3] : undefined;

  ref._throwIfRoot('uploadString');

  var data = dataFromString(format, value);
  var metadataClone = Object.assign({}, metadata);

  if (metadataClone['contentType'] == null && data.contentType != null) {
    metadataClone['contentType'] = data.contentType;
  }

  return uploadBytes(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */


function listAll(ref) {
  var accumulator = {
    prefixes: [],
    items: []
  };
  return listAllHelper(ref, accumulator).then(function () {
    return accumulator;
  });
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */


function listAllHelper(_x, _x2, _x3) {
  return _listAllHelper.apply(this, arguments);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */


function _listAllHelper() {
  _listAllHelper = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ref, accumulator, pageToken) {
    var _accumulator$prefixes, _accumulator$items;

    var opt, nextPage;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            opt = {
              // maxResults is 1000 by default.
              pageToken: pageToken
            };
            _context2.next = 3;
            return list$1(ref, opt);

          case 3:
            nextPage = _context2.sent;

            (_accumulator$prefixes = accumulator.prefixes).push.apply(_accumulator$prefixes, _toConsumableArray(nextPage.prefixes));

            (_accumulator$items = accumulator.items).push.apply(_accumulator$items, _toConsumableArray(nextPage.items));

            if (!(nextPage.nextPageToken != null)) {
              _context2.next = 9;
              break;
            }

            _context2.next = 9;
            return listAllHelper(ref, accumulator, nextPage.nextPageToken);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _listAllHelper.apply(this, arguments);
}

function list$1(_x4, _x5) {
  return _list$.apply(this, arguments);
}
/**
 * A promise that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */


function _list$() {
  _list$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ref, options) {
    var authToken, op, requestInfo;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (options != null) {
              if (typeof options.maxResults === 'number') {
                validateNumber('options.maxResults',
                /* minValue= */
                1,
                /* maxValue= */
                1000, options.maxResults);
              }
            }

            _context3.next = 3;
            return ref.storage._getAuthToken();

          case 3:
            authToken = _context3.sent;
            op = options || {};
            requestInfo = list(ref.storage, ref._location,
            /*delimiter= */
            '/', op.pageToken, op.maxResults);
            return _context3.abrupt("return", ref.storage._makeRequest(requestInfo, authToken).getPromise());

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _list$.apply(this, arguments);
}

function getMetadata$1(_x6) {
  return _getMetadata$.apply(this, arguments);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A promise that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */


function _getMetadata$() {
  _getMetadata$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ref) {
    var authToken, requestInfo;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            ref._throwIfRoot('getMetadata');

            _context4.next = 3;
            return ref.storage._getAuthToken();

          case 3:
            authToken = _context4.sent;
            requestInfo = getMetadata(ref.storage, ref._location, getMappings());
            return _context4.abrupt("return", ref.storage._makeRequest(requestInfo, authToken).getPromise());

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getMetadata$.apply(this, arguments);
}

function updateMetadata$1(_x7, _x8) {
  return _updateMetadata$.apply(this, arguments);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A promise that resolves with the download
 *     URL for this object.
 */


function _updateMetadata$() {
  _updateMetadata$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ref, metadata) {
    var authToken, requestInfo;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            ref._throwIfRoot('updateMetadata');

            _context5.next = 3;
            return ref.storage._getAuthToken();

          case 3:
            authToken = _context5.sent;
            requestInfo = updateMetadata(ref.storage, ref._location, metadata, getMappings());
            return _context5.abrupt("return", ref.storage._makeRequest(requestInfo, authToken).getPromise());

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _updateMetadata$.apply(this, arguments);
}

function getDownloadURL(_x9) {
  return _getDownloadURL.apply(this, arguments);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A promise that resolves if the deletion succeeds.
 */


function _getDownloadURL() {
  _getDownloadURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ref) {
    var authToken, requestInfo;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            ref._throwIfRoot('getDownloadURL');

            _context6.next = 3;
            return ref.storage._getAuthToken();

          case 3:
            authToken = _context6.sent;
            requestInfo = getDownloadUrl(ref.storage, ref._location, getMappings());
            return _context6.abrupt("return", ref.storage._makeRequest(requestInfo, authToken).getPromise().then(function (url) {
              if (url === null) {
                throw noDownloadURL();
              }

              return url;
            }));

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getDownloadURL.apply(this, arguments);
}

function deleteObject$1(_x10) {
  return _deleteObject$.apply(this, arguments);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */


function _deleteObject$() {
  _deleteObject$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(ref) {
    var authToken, requestInfo;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            ref._throwIfRoot('deleteObject');

            _context7.next = 3;
            return ref.storage._getAuthToken();

          case 3:
            authToken = _context7.sent;
            requestInfo = deleteObject(ref.storage, ref._location);
            return _context7.abrupt("return", ref.storage._makeRequest(requestInfo, authToken).getPromise());

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _deleteObject$.apply(this, arguments);
}

function _getChild(ref, childPath) {
  var newPath = child(ref._location.path, childPath);
  var location = new Location(ref._location.bucket, newPath);
  return new Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function isUrl(path) {
  return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */


function refFromURL(service, url) {
  return new Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */


function refFromPath(ref, path) {
  if (ref instanceof StorageService) {
    var service = ref;

    if (service._bucket == null) {
      throw noDefaultBucket();
    }

    var reference = new Reference(service, service._bucket);

    if (path != null) {
      return refFromPath(reference, path);
    } else {
      return reference;
    }
  } else {
    // ref is a Reference
    if (path !== undefined) {
      if (path.includes('..')) {
        throw invalidArgument('`path` param cannot contain ".."');
      }

      return _getChild(ref, path);
    } else {
      return ref;
    }
  }
}

function ref(serviceOrRef, pathOrUrl) {
  if (pathOrUrl && isUrl(pathOrUrl)) {
    if (serviceOrRef instanceof StorageService) {
      return refFromURL(serviceOrRef, pathOrUrl);
    } else {
      throw invalidArgument('To use ref(service, url), the first argument must be a Storage instance.');
    }
  } else {
    return refFromPath(serviceOrRef, pathOrUrl);
  }
}

function extractBucket(host, config) {
  var bucketString = config === null || config === void 0 ? void 0 : config[CONFIG_STORAGE_BUCKET_KEY];

  if (bucketString == null) {
    return null;
  }

  return Location.makeFromBucketSpec(bucketString, host);
}

function useStorageEmulator(storage, host, port) {
  storage.host = "http://".concat(host, ":").concat(port);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @public
 * @param opt_url - gs:// url to a custom Storage Bucket
 */


var StorageService = /*#__PURE__*/function () {
  function StorageService(
  /**
   * FirebaseApp associated with this StorageService instance.
   */
  app, _authProvider, _pool, _url, _firebaseVersion) {
    _classCallCheck(this, StorageService);

    this.app = app;
    this._authProvider = _authProvider;
    this._pool = _pool;
    this._url = _url;
    this._firebaseVersion = _firebaseVersion;
    this._bucket = null;
    /**
     * This string can be in the formats:
     * - host
     * - host:port
     * - protocol://host:port
     */

    this._host = DEFAULT_HOST;
    this._appId = null;
    this._deleted = false;
    this._maxOperationRetryTime = DEFAULT_MAX_OPERATION_RETRY_TIME;
    this._maxUploadRetryTime = DEFAULT_MAX_UPLOAD_RETRY_TIME;
    this._requests = new Set();

    if (_url != null) {
      this._bucket = Location.makeFromBucketSpec(_url, this._host);
    } else {
      this._bucket = extractBucket(this._host, this.app.options);
    }
  }

  _createClass(StorageService, [{
    key: "host",
    get: function get() {
      return this._host;
    }
    /**
     * Set host string for this service.
     * @param host - host string in the form of host, host:port,
     * or protocol://host:port
     */
    ,
    set: function set(host) {
      this._host = host;

      if (this._url != null) {
        this._bucket = Location.makeFromBucketSpec(this._url, host);
      } else {
        this._bucket = extractBucket(host, this.app.options);
      }
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */

  }, {
    key: "maxUploadRetryTime",
    get: function get() {
      return this._maxUploadRetryTime;
    },
    set: function set(time) {
      validateNumber('time',
      /* minValue=*/
      0,
      /* maxValue= */
      Number.POSITIVE_INFINITY, time);
      this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */

  }, {
    key: "maxOperationRetryTime",
    get: function get() {
      return this._maxOperationRetryTime;
    },
    set: function set(time) {
      validateNumber('time',
      /* minValue=*/
      0,
      /* maxValue= */
      Number.POSITIVE_INFINITY, time);
      this._maxOperationRetryTime = time;
    }
  }, {
    key: "_getAuthToken",
    value: function () {
      var _getAuthToken2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var auth, tokenData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                auth = this._authProvider.getImmediate({
                  optional: true
                });

                if (!auth) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return auth.getToken();

              case 4:
                tokenData = _context.sent;

                if (!(tokenData !== null)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", tokenData.accessToken);

              case 7:
                return _context.abrupt("return", null);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _getAuthToken() {
        return _getAuthToken2.apply(this, arguments);
      }

      return _getAuthToken;
    }()
    /**
     * Stop running requests and prevent more from being created.
     */

  }, {
    key: "_delete",
    value: function _delete() {
      this._deleted = true;

      this._requests.forEach(function (request) {
        return request.cancel();
      });

      this._requests.clear();

      return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */

  }, {
    key: "_makeStorageReference",
    value: function _makeStorageReference(loc) {
      return new Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */

  }, {
    key: "_makeRequest",
    value: function _makeRequest(requestInfo, authToken) {
      var _this14 = this;

      if (!this._deleted) {
        var request = makeRequest(requestInfo, this._appId, authToken, this._pool, this._firebaseVersion);

        this._requests.add(request); // Request removes itself from set when complete.


        request.getPromise().then(function () {
          return _this14._requests.delete(request);
        }, function () {
          return _this14._requests.delete(request);
        });
        return request;
      } else {
        return new FailRequest(appDeleted());
      }
    }
  }]);

  return StorageService;
}();

var name = "@firebase/storage";
var version = "0.0.900-exp.894b5da5a";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Type constant for Firebase Storage.
 */

var STORAGE_TYPE = 'storage-exp';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */

function uploadBytes$1(ref, data, metadata) {
  ref = getModularInstance(ref);
  return uploadBytes(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */


function uploadString$1(ref, value, format, metadata) {
  ref = getModularInstance(ref);
  return uploadString(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */


function uploadBytesResumable$1(ref, data, metadata) {
  ref = getModularInstance(ref);
  return uploadBytesResumable(ref, data, metadata);
}
/**
 * A promise that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */


function getMetadata$2(ref) {
  ref = getModularInstance(ref);
  return getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A promise that resolves with the new metadata for this object.
 */


function updateMetadata$2(ref, metadata) {
  ref = getModularInstance(ref);
  return updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */


function list$2(ref, options) {
  ref = getModularInstance(ref);
  return list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */


function listAll$1(ref) {
  ref = getModularInstance(ref);
  return listAll(ref);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A promise that resolves with the download
 *     URL for this object.
 */


function getDownloadURL$1(ref) {
  ref = getModularInstance(ref);
  return getDownloadURL(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A promise that resolves if the deletion succeeds.
 */


function deleteObject$2(ref) {
  ref = getModularInstance(ref);
  return deleteObject$1(ref);
}

function ref$1(serviceOrRef, pathOrUrl) {
  serviceOrRef = getModularInstance(serviceOrRef);
  return ref(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */


function _getChild$1(ref, childPath) {
  return _getChild(ref, childPath);
}
/**
 * Gets a Firebase StorageService instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get Storage instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A Firebase StorageService instance.
 */


function getStorage() {
  var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getApp();
  var bucketUrl = arguments.length > 1 ? arguments[1] : undefined;
  app = getModularInstance(app);

  var storageProvider = _getProvider(app, STORAGE_TYPE);

  var storageInstance = storageProvider.getImmediate({
    identifier: bucketUrl
  });
  return storageInstance;
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */

/**
 * Modify this `StorageService` instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The `StorageService` instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @public
 */


function useStorageEmulator$1(storage, host, port) {
  useStorageEmulator(storage, host, port);
}

function factory(container, _ref) {
  var url = _ref.instanceIdentifier;
  var app = container.getProvider('app-exp').getImmediate();
  var authProvider = container.getProvider('auth-internal');
  return new StorageService(app, authProvider, new XhrIoPool(), url, SDK_VERSION);
}

function registerStorage() {
  _registerComponent(new Component(STORAGE_TYPE, factory, "PUBLIC"
  /* PUBLIC */
  ).setMultipleInstances(true));

  registerVersion(name, version);
}

registerStorage();
export { StringFormat, FbsBlob as _FbsBlob, Location as _Location, UploadTask as _UploadTask, _getChild$1 as _getChild, deleteObject$2 as deleteObject, getDownloadURL$1 as getDownloadURL, getMetadata$2 as getMetadata, getStorage, list$2 as list, listAll$1 as listAll, ref$1 as ref, updateMetadata$2 as updateMetadata, uploadBytes$1 as uploadBytes, uploadBytesResumable$1 as uploadBytesResumable, uploadString$1 as uploadString, useStorageEmulator$1 as useStorageEmulator };